import React, { Component } from 'react';
import { reduxForm, Field } from 'redux-form';
import autoBind from 'react-autobind';
import classnames from 'classnames';
import Helmet from 'react-helmet';
import { injectIntl, FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import FormError from 'ui/common/form/form-error';
import CheckboxField from 'ui/common/form/fields/checkbox-field';
import SubmitButton from 'ui/common/form/submit-button';
import RequestedDelete from 'ui/users/details/requested-delete';
import styles from './index.module.scss';
import validator from 'ui/common/form/validator';
import model, { fieldNames } from './model';
import * as messages from './messages';
import { acceptCurrentTermsAndPrivacy } from 'store/features/auth/actions';
import { selectCurrentUserDeletionRequestedAt } from 'store/features/auth/selectors';

const { request: acceptCurrentTermsAndPrivacyRequest } = acceptCurrentTermsAndPrivacy;

const FORM_NAME = 'consent';

const validate = validator(model);

class Consent extends Component {
  constructor(props) {
    super(props);

    autoBind(this);
  }

  onSubmit(values) {
    const { acceptCurrentTermsAndPrivacyRequest, form } = this.props;

    acceptCurrentTermsAndPrivacyRequest(values, form);
  }

  render() {
    const {
      currentUserDeletionRequestedAt,
      handleSubmit,
      form: formName,
      intl: { formatMessage },
    } = this.props;

    if (currentUserDeletionRequestedAt) {
      return <RequestedDelete />;
    }

    return (
      <div className={classnames('py-4 container', styles.page)}>
        <Helmet>
          <title>{formatMessage(messages.header.title)}</title>
        </Helmet>
        <div
          className={classnames('row justify-content-center align-items-center', styles.pageRow)}
          style={{ marginTop: '7%' }}
        >
          <div className="col-12 col-sm-6">
            <h1 className="text-center pb-2" style={{ fontFamily: 'Neue Standard Medium' }}>
              <FormattedMessage id="header.privacy-policy" defaultMessage="Tribe Academy" />
            </h1>

            <h4 className="text-center pb-4" style={{ fontSize: '18px' }}>
              {formatMessage(messages.content.termsOfUseTitle)}
            </h4>
            <p className="pb-3" style={{ lineHeight: '24px' }}>
              <FormattedMessage
                {...messages.content.termsOfUseContent}
                values={{
                  privacy: (
                    <a href="https://tribeaccelerator.co/privacy-policy">(Privacy Policy)</a>
                  ),
                }}
              />
            </p>
            <form
              title={formatMessage(messages.header.title)}
              onSubmit={handleSubmit(this.onSubmit)}
            >
              <FormError formName={formName} />
              <div>
                <Field
                  name={fieldNames.acceptTermsAndConditions}
                  component={CheckboxField}
                  label={
                    <FormattedMessage
                      {...messages.labels.acceptTermsAndConditions}
                      values={{
                        privacy: (
                          <a href="https://tribeaccelerator.co/privacy-policy">Privacy Policy</a>
                        ),
                      }}
                    />
                  }
                />
              </div>
              <div className="mt-5 text-center">
                <SubmitButton isBlock textCenter isReady={true} formName={FORM_NAME}>
                  {formatMessage(messages.buttons.submit)}
                </SubmitButton>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    currentUserDeletionRequestedAt: selectCurrentUserDeletionRequestedAt(state),
  };
}

const mapDispatchToProps = { acceptCurrentTermsAndPrivacyRequest };

export default connect(mapStateToProps, mapDispatchToProps)(
  reduxForm({
    form: FORM_NAME,
    validate,
  })(injectIntl(Consent))
);



// WEBPACK FOOTER //
// ./src/ui/auth/consent/index.js